var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "roleBg",
    fill: "#77779F",
    d: "M7.786 2.651L10.437 0H0v10.437l2.651-2.651V2.65zM7.214 12.349L4.563 15H15V4.563l-2.651 2.651v5.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.536 0L0 12.536V15h2.464L15 2.465V0z"
  }))));
}
export default __webpack_public_path__ + "static/svg/roles/mid.svg";
export { SvgMid as ReactComponent };